/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_AgencyInputs */

const en_clients_field_agency = /** @type {(inputs: Clients_Field_AgencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agency`)
};

const pt_br2_clients_field_agency = /** @type {(inputs: Clients_Field_AgencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agência`)
};

/**
* | output |
* | --- |
* | "Agency" |
*
* @param {Clients_Field_AgencyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_agency = /** @type {((inputs?: Clients_Field_AgencyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_AgencyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_agency(inputs)
	return pt_br2_clients_field_agency(inputs)
});